import { buildCustomTypeFilePath } from "./buildCustomTypeFilePath.js";
import { writeProjectFile } from "./writeProjectFile.js";
const writeCustomTypeFile = async (args) => {
  const filePath = buildCustomTypeFilePath(args);
  const relativeFilePath = buildCustomTypeFilePath({
    ...args,
    absolute: false
  });
  await writeProjectFile({
    ...args,
    filename: relativeFilePath
  });
  return filePath;
};
export {
  writeCustomTypeFile
};
//# sourceMappingURL=writeCustomTypeFile.js.map
